// extracted by css-extract-rspack-plugin
export default {"cls1":"ActiveState-cls1_Ly9","cls2":"ActiveState-cls2_25U ActiveState-cls1_Ly9"};